import { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { FaFilePdf, FaDownload, FaEye } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import styles from './PDFViewer.module.scss';

const PDFViewer = ({ pdfUrl, title }) => {
  const [isHovered, setIsHovered] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const { t } = useTranslation();

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handleTouch = () => {
    if (isMobile) {
      setIsHovered(prev => !prev);
    }
  };

  return (
    <motion.div 
      className={styles.pdfViewer}
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
    >
      <div 
        className={styles.pdfCard}
        onMouseEnter={() => !isMobile && setIsHovered(true)}
        onMouseLeave={() => !isMobile && setIsHovered(false)}
        onClick={handleTouch}
      >
        <div className={styles.mainContent}>
          <div className={styles.leftSection}>
            <motion.div 
              className={styles.iconWrapper}
              animate={{ 
                scale: isHovered ? 1.05 : 1
              }}
              transition={{ duration: 0.3 }}
            >
              <FaFilePdf className={styles.pdfIcon} />
              <div className={styles.iconGlow} />
            </motion.div>
          </div>

          <div className={styles.centerSection}>
            <div className={styles.titleWrapper}>
              <h5>{title}</h5>
            </div>
            <motion.div 
              className={styles.progressBar}
              animate={{ 
                scaleX: isHovered ? 1 : 0,
                opacity: isHovered ? 1 : 0.7
              }}
              transition={{ duration: 0.3 }}
            />
          </div>

          <motion.div 
            className={styles.actions}
            animate={{ 
              opacity: isHovered ? 1 : 0.95
            }}
          >
            <motion.a
              href={pdfUrl}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.viewBtn}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              <span className={styles.btnContent}>
                <FaEye />
                <span>{t('projects.pdfViewer.view')}</span>
              </span>
            </motion.a>
            
            <motion.a
              href={pdfUrl}
              download
              className={styles.downloadBtn}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              <span className={styles.btnContent}>
                <FaDownload />
                <span>{t('projects.pdfViewer.download')}</span>
              </span>
            </motion.a>
          </motion.div>
        </div>
      </div>
    </motion.div>
  );
};

export default PDFViewer;